import React from "react";
import { graphql } from "gatsby";
import Container from "../components/container";
import GraphQLErrorList from "../components/graphql-error-list";
import Layout from "../containers/layout";
import Content from "../components/philosophy-content";
import SEO from "../components/seo";

export const query = graphql`
  query PhilosophyPageQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      ...SanitySiteSettingsFragment
      socialImage {
        asset {
          url
        }
      }
    }
    philosophy: sanityPhilosophy {
      ...SanityPhilosophyFragment
    }
  }
`;

const PhilosophyPage = (props) => {
  const { data, errors } = props;

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const site = (data || {}).site;
  const projectGridNodes = data.site.projectsGrid;
  const philosophy = (data || {}).philosophy;

  if (!site) {
    throw new Error(
      'Missing "Site settings". Open the studio at http://localhost:3333 and add some content to "Site settings" and restart the development server.'
    );
  }

  return (
    <Layout className="philosophy">
      <SEO title="Philosophy" description={site.description} keywords={site.keywords} ogImage={site?.socialImage?.asset?.url}/>
      <Container>
        <h1 hidden>philosophy</h1>
        <Content {...philosophy} projectGridNodes={projectGridNodes} />
      </Container>
    </Layout>
  );
};

export default PhilosophyPage;
